/***************************************************************************************
 * FileName      : BodyTypeResult2.js
 * Description   : 소곤핏고객 분석 결과 페이지(체형분석 완료 화면)
 * Company       : (주)엘리그
 * Author        : 최현민
 * Created Date  : 2024.11.26
 * Modifide Date : 
 *               :
 *               :
 * Reference     :
 ***************************************************************************************/
import { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Row, Col } from "react-bootstrap";
import MobileHeader from "../Component/MobileHeader";
import Gnb from "../../../Gnb";
import ReactGA from "react-ga4";
import { useRemoteConfig } from "@hackler/react-sdk";

import { getMe } from "../../../api/common/memberApi";
import { bbtiList } from "../../../api/services/bodytypeApi";
import { getBbtiMagazie } from "../../../api/services/magazine";

import { useNavigate } from "react-router-dom/dist";
import { useParams } from 'react-router-dom';

// 결과페이지 저장 및 링크복사 패키지
import html2canvas from 'html2canvas'; // html div -> img 전환
import clipboardCopy from 'clipboard-copy'; // 링크 복사

// BBTI 테스트 만족도 응답
import { researchSatisfaction } from '../../../api/services/bodytypeApi';


// 초기 로딩화면
function ResultSpinner() {
	return (
		<div className="text-center" style={{ padding: "45vh 0"}}>
			<div class="spin-body">
				<div class="spin-body__dot"></div>
				<div class="spin-body__dot"></div>
				<div class="spin-body__dot"></div>
			</div>
			<p>잠시만 기다려주세요.</p>
		</div>
	);
}


function SimpleTest2({}) {
	const { bbti } = useParams();
	const [userData, setUserData] = useState(); // 사용자 데이터
	const [bbtis, setBbtis] = useState(); // 체형 리스트
	const [userBodyType, setUserBodyType] = useState(bbti); // 사용자 체형(bbti) 정보
	const [showSpinner, setShowSpinner] = useState(true); // 3초 동안 스피너 표시

	const remoteConfig = useRemoteConfig(); // 핵클 원격구성 사용
	const parameterValue = remoteConfig.get("bbti_result_magazine", "");

	const [magazineContent, setMagazineContent] = useState([]);
	// 페이지 로딩 시 3초 동안 스피너를 강제로 표시
	useEffect(() => {
		const timer = setTimeout(() => {
			setShowSpinner(false);
		}, 3000);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		getMe()
			.then((res) => {
				setUserData(res);
			})
			.catch((err) => {
				setUserData("guest");
			});
	}, []);

	useEffect(() => {
		bbtiList().then((res) => {
			setBbtis(res?.data?.data);
		});
		getBbtiMagazie(bbti).then((res) =>
			setMagazineContent(res?.data?.data)
		);
	}, []);

	// 화면 캡쳐용 함수
	const containerRef = useRef(null);
	const handleCapture = () => {
		// 화면 캡처
		html2canvas(containerRef.current).then((canvas) => {
			// 캔버스를 이미지로 변환
			const image = canvas.toDataURL('image/png');

			// 이미지 다운로드 링크 생성
			const a = document.createElement('a');
			a.href = image;
			a.download = 'captured-image.png';
			a.click();
		});
	};

	const bodyTypes = {
		UOW: {
			style: "바꾸로 기다마니",
			type: ["#벌어진가슴형", "#윗가슴빈약형", "#볼륨발달형"],
			worry: [
				"와이어의 끝이 가슴을 압박해서 답답할 때가 많아요",
				"브라를 입으면 가슴 앞쪽 부분은 컵이 남고, 들떠요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는 게 신경쓰여요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 들떠요",
				"셔츠의 어깨선이 뒤쪽으로 처질 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
			],
		},
		UOA: {
			style: "나라니 넉넉한",
			type: ["#윗가슴빈약형", "#짝가슴형", "#볼륨발달형"],
			worry: [
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요",
				"어깨가 앞으로 말리고 어깨가 결릴 때가 많아요",
				"등 쪽 브라의 둘레 밴드가 자꾸 위로 따라 올라가요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"가슴을 모아서 입어도 어차피 금방 들떠요",
			],
		},
		UOC: {
			style: "아래루 기다마니",
			type: ["#처진가슴형", "#윗가슴빈약형", "#볼륨발달형"],
			worry: [
				"가슴 아랫 부분이 몸통에 닿아 땀이 찰 때가 많아요",
				"브라의 앞 중심 사이로 가슴이 쏠리거나 빠져나올 때가 있어서 신경 쓰여요",
				"브라의 컵 윗부분에 공간이 남는 편이에요"
			],
			point: [
				"가슴 아래쪽 부분이 몸과 닿아 땀이차요",
				"편한 컵 사이즈를 입으면 가슴 윗쪽이 들떠요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		URW: {
			style: "바꾸루 너그러브",
			type: ["#퍼진가슴형", "#윗가슴빈약형", "#벌어진가슴형"],
			worry: [
				"브라를 입으면 가슴 앞쪽 부분은 컵이 남아서 들뜨는 편이에요",
				"와이어의 끝이 가슴을 압박해서 답답할 때가 많아요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는 게 신경쓰여요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 들떠요",
				"실제보다 브라를 입으면 빈약해 보이는 편이에요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
			],
		},
		URA: {
			style: "너그러브 완만한",
			type: ["#윗가슴빈약형", "#짝가슴형", "#완만한볼륨형"],
			worry: [
				"어깨끈이 자주 흘러 내리는 편이에요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"가슴을 모아서 입어도 어차피 금방 들떠요",
			],
		},
		URC: {
			style: "아래루 너그러브",
			type: ["#윗가슴빈약형", "#완만한볼륨형", "#처진가슴형"],
			worry: [
				"브라의 컵 윗부분에 공간이 남는 편이에요",
				"브라의 앞 중심 사이로 가슴이 쏠리거나 빠져나올 때가 있어서 신경 쓰여요",
				"등 쪽 브라의 둘레 밴드가 자꾸 위로 따라 올라가요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"편한 컵 사이즈를 입으면 가슴 윗쪽이 들떠요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		UIW: {
			style: "바꾸루 암팡지니",
			type: ["#윗가슴빈약형", "#작은가슴형", "#벌어진가슴형"],
			worry: [
				"가슴을 아무리 열심히 모아도 어차피 금방 다 퍼져요",
				"가슴이 사이가 멀고 벌어져 있는 느낌이 들어요",
				"브라의 컵이 자주 들떠요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 들떠요",
				"셔츠의 어깨선이 뒤쪽으로 처질 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
			],
		},
		UIA: {
			style: "암팡지니 완만한",
			type: ["#윗가슴빈약형", "#짝가슴형", "#작은가슴형"],
			worry: [
				"가슴을 아무리 열심히 모아도 어차피 브라가 다 떠요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가요",
				"어깨끈이 자주 흘러 내리는 편이에요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"가슴을 모아서 입어도 어차피 금방 들떠요",
			],
		},
		UIC: {
			style: "아래루 암팡지니",
			type: ["#윗가슴빈약형", "#처진가슴형", "#작은가슴형"],
			worry: [
				"브라의 컵 윗부분에 공간이 남는 편이에요",
				"브라의 앞 중심 사이로 가슴이 쏠리거나 빠져나올 때가 있어서 신경 쓰여요",
				"등 쪽 브라의 둘레 밴드가 자꾸 위로 따라 올라가요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"편한 컵 사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		MOW: {
			style: "바꾸루 넉넉한",
			type: ["#뾰족한가슴형", "#볼륨발달형", "#벌어진가슴형"],
			worry: [
				"브라를 입으면 가슴 앞쪽 부분은 컵이 남는 편이에요",
				"와이어의 끝이 가슴을 압박해서 답답할 때가 많아요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는 게 신경쓰여요"
			],
			point: [
				"상체가 너무 부해보이는게 고민이에요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"셔츠의 어깨선이 뒤쪽으로 처질 때가 많아요",
			],
		},
		MOA: {
			style: "두루뭉실 여유로운",
			type: ["#뾰족한가슴형", "#짝가슴형", "#볼륨발달형"],
			worry: [
				"어깨끈이 자주 흘러 내려요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"브라에 따라 가슴만 뽀족한 느낌이 들 때가 있어요",
			],
		},
		MOC: {
			style: "아래루 넉넉한",
			type: ["#뾰족한가슴형", "#볼륨발달형", "#처진가슴형"],
			worry: [
				"등 쪽 브라의 둘레 밴드가 자꾸 위로 따라 올라가요",
				"가슴 아랫 부분이 몸통에 닿아 땀이 찰 때가 많아요",
				"브라의 앞 중심 사이로 가슴이 쏠리거나 빠져나올 때가 있어서 신경 쓰여요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"가슴 아래쪽 부분이 몸과 닿아 땀이 차요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		MRW: {
			style: "넉너기 완만한",
			type: [
				"#뾰족한가슴형",
				"#완만한볼륨형",
				"#퍼진가슴형",
				"#벌어진가슴",
			],
			worry: [
				"와이어의 끝이 가슴을 압박해서 답답할 때가 많아요",
				"브라를 입으면 가슴 앞쪽 부분은 컵이 남는 편이에요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는 게 신경쓰여요"
			],
			point: [
				"가슴이 실제보다 브라를 입은 후에 더 작아보여요",
				"브라에 다라 가슴만 뾰족한 느낌이 들 때가 있어요",
				"사이즈는 맞는데 컵 안쪽이 꽉 차는 느낌이 안나요",
			],
		},
		MRA: {
			style: "뾰조록이 완만한",
			type: ["#뾰족한가슴형", "#완만한볼륨형", "#짝가슴형"],
			worry: [
				"어깨끈이 자주 흘러 내리는 편이에요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요"
			],
			point: [
				"브라의 중심이 한쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"사이즈는 맞는데 컵 안쪽이 꽉 차는 느낌이 안나요",
			],
		},
		MRC: {
			style: "누그시 완만한",
			type: ["#뾰족한가슴형", "#완만한볼륨형", "#처진가슴형"],
			worry: [
				"브라의 컵 윗부분에 공간이 남는 편이에요",
				"등 쪽 브라의 둘레 밴드가 자꾸 위로 따라 올라가요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는 게 신경쓰여요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"가슴 아래쪽 부분이 몸과 닿아 땀이 차요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		MIW: {
			style: "바꾸루 뾰조록한",
			type: ["#뾰족한가슴형", "#벌어진가슴형", "#작은가슴형"],
			worry: [
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"브라를 착용했을 때 컵의 안쪽이 비어있는 경우가 많아요",
				"가슴이 사이가 멀고 벌어져 있는 느낌이 들어요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 들떠요",
				"와이어읜 끝이 가슴을 압박해서 답답해요",
				"사이즈는 맞는데 컵 안쪽이 꽉 차는 느낌이 안나요",
			],
		},
		MIA: {
			style: "뾰조록이 아담한",
			type: ["#뾰족한가슴형", "#짝가슴형", "#작은가슴형"],
			worry: [
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요",
				"어깨끈이 자주 흘러 내리는 편이에요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"사이즈는 맞는데 컵 안쪽이 꽉 차는 느낌이 안나요",
			],
		},
		MIC: {
			style: "아래루 뾰조록한",
			type: ["#뾰족한가슴형", "#처진가슴형", "#작은가슴형"],
			worry: [
				"브라의 컵 윗부분에 공간이 남는 편이에요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요",
				"브라를 착용했을 때 컵의 안쪽이 비어있는 경우가 많아요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"편한 정도의 컵 사이즈를 입으면 윗쪽이 비어요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		TOW: {
			style: "바꾸루 두루뭉실",
			type: [
				"#윗가슴발달형",
				"#벌어진가슴형",
				"#볼륨발달형",
				"#둥근가슴형",
			],
			worry: [
				"가슴을 모아도 가슴 골이 유지되지 않고 금방 퍼져요",
				"컵 위로 가슴살이 눌려서 튀어나오는 경우가 많아요",
				"가슴 중앙 뼈가 돌출되어 볼록한 느낌이에요"
			],
			point: [
				"상체가 너무 부해보이는게 고민이에요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"와이어가 빠지거나 부러져서 버리는 편이에요",
			],
		},
		TOA: {
			style: "두루뭉실 빵빵한",
			type: ["#윗가슴발달형", "#짝가슴형", "#볼륨발달형", "#둥근가슴형"],
			worry: [
				"브라의 컵이 윗가슴을 안정적으로 감싸면 좋겠어요",
				"컵 위로 가슴살이 눌려서 튀어나오는 경우가 많아요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나는게 신경쓰여요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"상체가 너무 부해보이는게 고민이에요",
				"와이어가 빠지거나 부러져서 버리는 편이에요",
			],
		},
		TOC: {
			style: "아래루 두루뭉실",
			type: [
				"#윗가슴발달형",
				"#처진가슴형",
				"#볼륨발달형",
				"#둥근가슴형",
			],
			worry: [
				"브라의 컵이 윗가슴을 안정적으로 감싸면 좋겠어요",
				"어깨가 앞으로 말리고 어깨가 결릴 때가 많아요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나지 않았으면 좋겠어요"
			],
			point: [
				"상체가 너무 부해보이는게 고민이에요",
				"가슴 밑라인 부분이 몸과 닿아 땀이 차요",
				"와이어가 빠지거나 부러져서 버리는 편이에요",
			],
		},
		TRW: {
			style: "바꾸루 완만한",
			type: [
				"#둥근가슴형",
				"#벌어진가슴형",
				"#완만한볼륨형",
				"#퍼진가슴형",
			],
			worry: [
				"가슴이 사이가 멀고 벌어져 있는 느낌이 들어요",
				"와이어의 끝이 가슴을 압박해서 답답할 때가 있어요",
				"가슴을 모아도 가슴 골이 유지되지 않고 금방 퍼져요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 퍼져요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"브라의 와이어 앞쪽이 들떠서 불편해요",
			],
		},
		TRA: {
			style: "두루몽실 완만한",
			type: ["#둥근가슴형", "#짝가슴형", "#완만한볼륨형"],
			worry: [
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요",
				"어깨끈이 자주 흘러 내리는 편이에요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"와이어가 빠지거나 부러져서 버리는 편이에요",
			],
		},
		TRC: {
			style: "아래루 완만한",
			type: ["#둥근가슴형", "#처진가슴형", "#완만한볼륨형"],
			worry: [
				"브라의 컵이 윗가슴을 안정적으로 감싸면 좋겠어요",
				"브라의 앞 중심 사이로 가슴이 쏠리거나 빠져나올 때가 있어서 신경 쓰여요",
				"브라를 입으면 등살과 겨드랑이 밑 부분이 감싸지지 않고 울룩불룩 티가 나지 않았으면 좋겠어요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"가슴 밑라인 부분이 몸과 닿아 땀이 차요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
		TIW: {
			style: "바꾸루 아담한",
			type: ["#퍼진가슴형", "#작은가슴형", "#벌어진가슴형"],
			worry: [
				"와이어의 끝이 가슴을 압박해서 답답해요",
				"브라를 착용했을 때 컵의 안쪽이 비어있는 경우가 많아요",
				"가슴이 사이가 멀고 벌어져 있는 느낌이 들어요"
			],
			point: [
				"가슴을 모아서 입어도 어차피 금방 들떠요",
				"와이어의 끝이 가슴을 찌르는 느낌이라 답답해요",
				"컵의 아래쪽인 앞둘레 밴드가 위로 따라 올라가요",
			],
		},
		TIA: {
			style: "두루뭉실 아담한",
			type: ["#짝가슴형", "#작은가슴형", "#완만한가슴형"],
			worry: [
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요",
				"양쪽의 가슴 크기가 달라서 브라 사이즈 선택하기가 애매해요",
				"어깨끈이 자주 흘러 내리는 편이에요"
			],
			point: [
				"브라의 중심이 한 쪽으로 쏠려있을 때가 많아요",
				"와이어의 끝이 가슴을 찌르는 느낌이라 답답해요",
				"컵의 아래쪽인 앞둘레 밴드가 위로 따라 올라가요",
			],
		},
		TIC: {
			style: "아래루 아담한",
			type: ["#처진가슴형", "#작은가슴형", "#완만한가슴형"],
			worry: [
				"브라의 컵 윗부분에 공간이 남는 편이에요",
				"팔을 머리 위로 올리고 몸을 좌우로 움직였을 때 브라가 함께 올라가거나 접혀요",
				"브라를 착용했을 때 컵의 안쪽이 비어있는 경우가 많아요"
			],
			point: [
				"유두의 위치가 팔꿈치와 5cm 내외로 가까워요",
				"와이어의 끝이 몸에 딱 닿아서 갑갑해요",
				"딱 맞는 컵사이즈를 입으면 앞중심 사이로 가슴이 쏠리거나 빠져나오려고 해요",
			],
		},
	};
	
	return (
		<>
			<Helmet>
				<title>소곤핏 sogonfit - 분석(결과)</title>
			</Helmet>
			<MobileHeader back={true} title={"검사결과"} />
			<div
				className="bbtitest"
				style={{ margin: "48px auto", paddingBottom: "64px", background: "#f7f3e4" }}
			>
				{showSpinner ? (
					<ResultSpinner />
				) : (
					<div className="inner" ref={containerRef}>
						<p className="text-center fs-4 fw-bold my-4">
							{userData?.nickname ?? "비회원"}님은<br/>
							<span className="fc-main fw-bold">{bodyTypes[userBodyType]?.style}({userBodyType})</span> 체형을 가진<br/>소곤이입니다.
						</p>
						<div style={{
							borderRadius: "4px",
							background: "#fff",
							boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.1)",
							padding: "20px 8px"
						}}>
							<p className="text-center fc-gray" style={{fontSize: "14px"}}>보편적으로는 이런 형태로 표현되고있어요</p>
							<div style={{
								display: "flex",
								justifyContent: "space-around",
								paddingTop: "8px",
								paddingBottom: "12px",
							}}>
								<p className="fc-main">{bodyTypes[userBodyType]?.type[0]}</p>
								<p className="fc-main">{bodyTypes[userBodyType]?.type[1]}</p>
								<p className="fc-main">{bodyTypes[userBodyType]?.type[2]}</p>
							</div>
							<hr style={{
								color: "#e85f43",
								margin: "8px",
							}}/>

							<div style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
							}}>
								<img src={`../img/bbti/result/side/${userBodyType}.png`} className="w-50 p-3"/>
								<img src={`../img/bbti/result/front/${userBodyType}.png`} className="w-50 p-3"/>
							</div>
							<hr style={{
								color: "#e85f43",
								margin: "8px",
							}}/>

							<div className="text-center my-5">
								<p className="fc-main fw-bold my-3">이런 고민을 자주 하시지 않나요?</p>
								<p className="fc-gray mb-1" style={{fontSize: "14px"}}>{'"'+bodyTypes[userBodyType]?.worry[0]+'"'}</p>
								<p className="fc-gray mb-1" style={{fontSize: "14px"}}>{'"'+bodyTypes[userBodyType]?.worry[1]+'"'}</p>
								<p className="fc-gray mb-1" style={{fontSize: "14px"}}>{'"'+bodyTypes[userBodyType]?.worry[2]+'"'}</p>
							</div>
							<hr style={{
								color: "#e85f43",
								margin: "8px",
							}}/>

							<div className="text-center my-5">
								<p className="fc-main fw-bold my-3">{userBodyType}는 이런 체형이에요.</p>
								<p className="fc-gray" style={{fontSize: "14px"}}>{bodyTypes[userBodyType]?.point[0]}</p>
								<p className="fc-gray" style={{fontSize: "14px"}}>{bodyTypes[userBodyType]?.point[1]}</p>
								<p className="fc-gray" style={{fontSize: "14px"}}>{bodyTypes[userBodyType]?.point[2]}</p>
							</div>
							<hr style={{
								color: "#e85f43",
								margin: "8px",
							}}/>
							<div className="p-3">
								<p className="text-center fw-bold mb-3">
									도움이 될 만한 콘텐츠에요.
								</p>
								{magazineContent?.length > 0
									? magazineContent.map(
											(item, index) =>
												index <
													JSON.parse(parameterValue)
														?.maxContent && (
													<MagazineBlock
														item={item}
														key={item?.id}
													/>
												)
										)
									: "매거진이 없습니다."}
							</div>
						</div>
						<ShareArea handleCapture={handleCapture} />
					</div>
				)}
				<Gnb />
			</div>
		</>
	);
}

// 테스트 결과 공유하기
function ShareArea({handleCapture}) {
	// 쿠키에서 UUID 읽기
	const getBBTICookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	};

	// UUID 상태 설정
	const [uuid, setUUID] = useState('');

	// 컴포넌트 마운트 시 쿠키에서 UUID 읽어오기
	useEffect(() => {
		const cookieUuid = getBBTICookie('bbtiUuid');
		if (cookieUuid) {
			setUUID(cookieUuid);
		}
	}, []);

	// 카카오 공유 전용 스크립트
	useEffect(() => {
		if (!window?.Kakao?.isInitialized()) {
			window?.Kakao?.init('0907d499eb79097f57e355d7a8831723');
		}
	  }, []);
	// Kakao Link 보내기
	const handleKakaoShare = () => {
	  window?.Kakao?.Share.sendDefault({
		objectType: 'feed',
		content: {
		  title: 'BBTI 테스트',
		  description: '내 BBTI 테스트 결과 공유',
		  imageUrl: 'https://www.sogonfit.com/img/bbti/bbti-test-thumbnail.jpeg',
		  link: {
			mobileWebUrl: 'https://www.sogonfit.com/bbti',
			webUrl: 'https://www.sogonfit.com/bbti',
		  },
		},
	  });
	};

	const LinkIcon = () => (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#000">
						<path d="M12.8944 17.4713C13.0349 17.6119 13.1139 17.8026 13.1139 18.0014C13.1139 18.2002 13.0349 18.3909 12.8944 18.5316L11.9625 19.4691C10.977 20.4539 9.64066 21.007 8.24741 21.0065C6.85416 21.0061 5.51815 20.4522 4.53329 19.4667C3.54842 18.4812 2.99538 17.1449 2.99582 15.7516C2.99626 14.3584 3.55015 13.0224 4.53563 12.0375L6.79688 9.77626C7.74346 8.82892 9.01629 8.27914 10.3549 8.2394C11.6935 8.19967 12.9967 8.67299 13.9978 9.56251C14.0717 9.62801 14.1319 9.70741 14.1751 9.79619C14.2183 9.88497 14.2436 9.98139 14.2495 10.0799C14.2554 10.1785 14.2419 10.2772 14.2096 10.3705C14.1774 10.4638 14.1271 10.5499 14.0616 10.6238C13.9961 10.6976 13.9167 10.7579 13.8279 10.8011C13.7391 10.8442 13.6427 10.8695 13.5441 10.8754C13.4456 10.8813 13.3469 10.8678 13.2535 10.8356C13.1602 10.8033 13.0742 10.753 13.0003 10.6875C12.2853 10.0525 11.3547 9.71473 10.3989 9.74313C9.44306 9.77153 8.53418 10.164 7.85813 10.8403L5.59688 13.0988C4.89348 13.8022 4.49831 14.7562 4.49831 15.7509C4.49831 16.7457 4.89348 17.6997 5.59688 18.4031C6.30029 19.1065 7.25431 19.5017 8.24907 19.5017C9.24383 19.5017 10.1979 19.1065 10.9013 18.4031L11.8331 17.4713C11.9028 17.4015 11.9855 17.3462 12.0766 17.3085C12.1676 17.2707 12.2652 17.2513 12.3638 17.2513C12.4623 17.2513 12.5599 17.2707 12.651 17.3085C12.742 17.3462 12.8247 17.4015 12.8944 17.4713ZM19.4644 4.53376C18.4788 3.55034 17.1433 2.99805 15.7509 2.99805C14.3586 2.99805 13.0231 3.55034 12.0375 4.53376L11.1056 5.46657C10.965 5.6073 10.8861 5.79813 10.8862 5.99706C10.8863 6.196 10.9654 6.38675 11.1061 6.52736C11.2468 6.66796 11.4377 6.7469 11.6366 6.74682C11.8355 6.74673 12.0263 6.66762 12.1669 6.52689L13.0988 5.59501C13.8022 4.89161 14.7562 4.49644 15.7509 4.49644C16.7457 4.49644 17.6997 4.89161 18.4031 5.59501C19.1065 6.29842 19.5017 7.25244 19.5017 8.2472C19.5017 9.24196 19.1065 10.196 18.4031 10.8994L16.1419 13.1625C15.4655 13.8384 14.5564 14.2304 13.6006 14.2583C12.6447 14.2862 11.7144 13.9478 10.9997 13.3125C10.8505 13.1802 10.6549 13.1126 10.4559 13.1246C10.2568 13.1365 10.0707 13.2271 9.93845 13.3763C9.80617 13.5254 9.73857 13.7211 9.75053 13.9201C9.76248 14.1191 9.85301 14.3052 10.0022 14.4375C11.0031 15.3273 12.3061 15.8009 13.6447 15.7615C14.9833 15.7222 16.2563 15.1727 17.2031 14.2256L19.4644 11.9644C20.4484 10.9787 21.001 9.6428 21.001 8.25001C21.001 6.85722 20.4484 5.52134 19.4644 4.53564V4.53376Z" fill="black"/>
					</svg>
	);
	  
	const KakaoIcon = () => (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#000">
						<path d="M12 3C17.8 3 22.501 6.664 22.501 11.185C22.501 15.705 17.8 19.369 12.001 19.369C11.4236 19.3693 10.8467 19.3325 10.274 19.259L5.86601 22.142C5.36501 22.407 5.18801 22.378 5.39401 21.729L6.28601 18.051C3.40601 16.591 1.50101 14.061 1.50101 11.185C1.50101 6.665 6.20101 3 12.001 3H12ZM17.908 11.06L19.378 9.636C19.4628 9.54791 19.5102 9.43033 19.51 9.30804C19.5099 9.18575 19.4623 9.0683 19.3772 8.98041C19.2922 8.89252 19.1764 8.84107 19.0541 8.83689C18.9319 8.83271 18.8128 8.87613 18.722 8.958L16.794 10.824V9.282C16.794 9.15682 16.7443 9.03676 16.6558 8.94825C16.5672 8.85973 16.4472 8.81 16.322 8.81C16.1968 8.81 16.0768 8.85973 15.9883 8.94825C15.8997 9.03676 15.85 9.15682 15.85 9.282V11.839C15.8324 11.9119 15.8324 11.9881 15.85 12.061V13.5C15.85 13.6252 15.8997 13.7452 15.9883 13.8338C16.0768 13.9223 16.1968 13.972 16.322 13.972C16.4472 13.972 16.5672 13.9223 16.6558 13.8338C16.7443 13.7452 16.794 13.6252 16.794 13.5V12.137L17.221 11.724L18.649 13.757C18.6847 13.8078 18.73 13.851 18.7823 13.8842C18.8347 13.9175 18.8931 13.9401 18.9542 13.9508C19.0153 13.9615 19.0779 13.96 19.1384 13.9465C19.199 13.933 19.2563 13.9077 19.307 13.872C19.3578 13.8363 19.401 13.791 19.4342 13.7387C19.4675 13.6863 19.4901 13.6279 19.5008 13.5668C19.5115 13.5057 19.51 13.4431 19.4965 13.3826C19.483 13.322 19.4577 13.2648 19.422 13.214L17.908 11.059V11.06ZM14.95 12.984H13.49V9.297C13.4844 9.17571 13.4323 9.06123 13.3445 8.97737C13.2567 8.89351 13.1399 8.84672 13.0185 8.84672C12.8971 8.84672 12.7803 8.89351 12.6925 8.97737C12.6047 9.06123 12.5526 9.17571 12.547 9.297V13.456C12.547 13.716 12.757 13.928 13.018 13.928H14.95C15.0752 13.928 15.1952 13.8783 15.2838 13.7898C15.3723 13.7012 15.422 13.5812 15.422 13.456C15.422 13.3308 15.3723 13.2108 15.2838 13.1222C15.1952 13.0337 15.0752 12.984 14.95 12.984ZM9.09301 11.893L9.78901 10.185L10.427 11.892L9.09301 11.893ZM11.616 12.38L11.618 12.364C11.6178 12.2451 11.5724 12.1307 11.491 12.044L10.445 9.244C10.4012 9.11057 10.3176 8.99369 10.2056 8.90899C10.0936 8.8243 9.95834 8.7758 9.81801 8.77C9.67665 8.76938 9.53845 8.81182 9.4218 8.89167C9.30515 8.97152 9.21558 9.08499 9.16501 9.217L7.50301 13.292C7.45567 13.4079 7.45631 13.5379 7.50478 13.6533C7.55326 13.7687 7.64561 13.8602 7.76151 13.9075C7.87741 13.9548 8.00737 13.9542 8.12279 13.9057C8.23822 13.8572 8.32967 13.7649 8.37701 13.649L8.70901 12.836H10.779L11.077 13.636C11.0973 13.6958 11.1295 13.7509 11.1715 13.7981C11.2135 13.8452 11.2645 13.8835 11.3216 13.9105C11.3787 13.9376 11.4406 13.9529 11.5037 13.9557C11.5668 13.9584 11.6298 13.9484 11.689 13.9263C11.7481 13.9042 11.8023 13.8704 11.8482 13.8271C11.8941 13.7837 11.9308 13.7315 11.9561 13.6737C11.9815 13.6158 11.995 13.5535 11.9958 13.4903C11.9967 13.4272 11.9848 13.3645 11.961 13.306L11.616 12.38ZM8.29401 9.302C8.29401 9.17699 8.24442 9.05709 8.15612 8.9686C8.06781 8.88011 7.94802 8.83026 7.82301 8.83H4.57801C4.45283 8.83 4.33277 8.87973 4.24425 8.96825C4.15574 9.05676 4.10601 9.17682 4.10601 9.302C4.10601 9.42718 4.15574 9.54724 4.24425 9.63575C4.33277 9.72427 4.45283 9.774 4.57801 9.774H5.73801V13.51C5.73801 13.6352 5.78774 13.7552 5.87625 13.8438C5.96477 13.9323 6.08483 13.982 6.21001 13.982C6.33519 13.982 6.45524 13.9323 6.54376 13.8438C6.63228 13.7552 6.68201 13.6352 6.68201 13.51V9.774H7.82201C7.94719 9.774 8.06724 9.72427 8.15576 9.63575C8.24428 9.54724 8.29401 9.42718 8.29401 9.302Z" fill="black"/>
					</svg>
	);
	  
	const DownloadIcon = () => (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#000">
		  	<path d="M12 15L17 10L15.9 8.9L13 11.7V4H11V11.7L8.1 8.9L7 10L12 15Z"/>
		  	<path d="M5 18V20H19V18H5ZM19 20C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18V16H19V18H5V16H3V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H19Z"/>
		</svg>
	);

	return(
		<div className='p-3'>
			<Row>
				<Col>
					<p className='pt-4 pb-2 fs-8 fw-bold text-center'>이번 테스트 어땠나요?</p>
				</Col>
			</Row>
			<Row className='px-3'>
				<Col xs={4} className='py-2'>
					<div className='share bg-light text-center rounded-2 fs-8 py-2 pointer border'
						onClick={()=>{
							researchSatisfaction(uuid, 'FUN')
								.then(res => {alert('감사합니다🙂')})
							}
						}
					>
						<span className='fs-5'>🙂</span><br/>
						<p className="">유익해요</p>
					</div>
				</Col>
				<Col xs={4} className='py-2'>
					<div className='share bg-light text-center rounded-2 fs-8 py-2 pointer border'
						onClick={()=>{
							researchSatisfaction(uuid, 'USEFUL')
								.then(res => alert('소중한 의견을 적극 반영하겠습니다🙂'))
							}
						}
					>
						<span className='fs-5'>🤔</span><br/>
						<p className="">모르겠어요</p>
					</div>
				</Col>
				<Col xs={4} className='py-2'>
					<div className='share bg-light text-center rounded-2 fs-8 py-2 pointer border'
						onClick={()=>{
							researchSatisfaction(uuid, 'NOT_GOOD')
								.then(res => alert('소중한 의견을 적극 반영하겠습니다🙂'))
							}
						}
					>
						<span className='fs-5'>😥</span><br/>
						<p className="">별로에요</p>
					</div>
				</Col>
			</Row>
			<Row className='pt-4'>
				<Col>
					<p className='py-2 fs-8 fw-bold text-center'>친구에게 공유하기</p>
				</Col>
			</Row>
			
			<Row className="py-1">
				<Col xs={2}></Col>
				<Col xs={2} className='text-center border rounded-1 py-3 pointer' onClick={()=>{
					clipboardCopy('https://www.sogonfit.com/bbti/');
					alert('링크가 복사되었습니다.');
				}}>
					<LinkIcon />
				</Col>
				<Col xs={1}></Col>
				<Col xs={2} className='text-center border rounded-1 py-3 pointer' onClick={handleKakaoShare}>
					<KakaoIcon />
				</Col>
				<Col xs={1}></Col>
				<Col xs={2} className='text-center border rounded-1 py-3 pointer' onClick={handleCapture}>
					<DownloadIcon />
				</Col>
				<Col xs={2}></Col>
			</Row>

			{/*
			<Row>
				<Col className='pt-4'>
					<p className="bg-main text-white fs-9 fw-bold rounded-2 text-center py-2 pointer" onClick={handleCapture}>로그인하고 결과 저장하기</p>
				</Col>
			</Row>
			*/}
			<Row>
				<Col className='py-3'>
					{/* <p className="text-light border-white fs-9 fw-bold rounded-2 text-center py-2 pointer" onClick={()=>navigate("/bbti")}>다시 테스트하기</p> */}
					<p className="fc-main bg-light fs-9 fw-bold rounded-2 text-center py-2 pointer" onClick={()=>window.location.href="/bbti"}>다시 테스트하기</p>
				</Col>
			</Row>
		</div>
	)
}


function MagazineBlock({ item }) {
	const navigate = useNavigate();
	return (
		<>
			<div
				className="my-magazine-content"
				style={{boxShadow: "none"}}
				onClick={() => {
					window.hackleClient.track({
						key: "clicked_sogonlog",
						properties: {
							클릭위치: "체형분석 결과페이지",
							타이틀: item?.title,
							글작성자: item?.user?.username,
							카테고리: item?.category?.name,
							레이아웃: "요약리스트형",
						},
					});
					ReactGA.event({
						category: "체형분석 결과페이지에서 클릭한 매거진",
						action: "Magazine Clicked",
						value: item?.id,
					});
					navigate(`/magazine/${item?.id}`);
				}}
			>
				<div className="my-m-img">
					<img src={item?.main_image} alt={item?.title} />
				</div>

				<div className="magazine-info">
					<div className="post-tit">
						<p className="fw-bold pe-3">{item?.title}</p>
					</div>
					<div className="post-tags">
						<span
							key={item?.category?.id}
							className="post-tag"
							style={{ padding: "4px 6px 4px 0px" }}
						>
							{item?.category?.name}
						</span>
					</div>
				</div>
			</div>
		</>
	);
}

export default SimpleTest2;
